import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ApiClient} from "../../tools/api-client";
import {Analysis, DoctorFindings} from "./analysis";
import {map} from "rxjs/operators";
import {recursiveNullToUndefined} from "../../tools/recursive-null-to-undefined";
import {Doctor} from "../list/doctor";

@Injectable()
export class AnalysisService {
  constructor(private readonly apiClient: ApiClient) {
  }

  getAnalysis(measurementId: number): Observable<Analysis> {
    return this.apiClient
      .get<Analysis>(`/api/measurements/${measurementId}/analysis`)
      .pipe(map(analysis => recursiveNullToUndefined(analysis)));
  }

  saveAnalysis(measurementId: number, doctorFindings: DoctorFindings): Observable<Analysis> {
    return this.apiClient
      .put<Analysis>(
      `/api/measurements/${measurementId}/analysis`,
      doctorFindings
    )
      .pipe(map(analysis => recursiveNullToUndefined(analysis)));
  }

  getSamplesReport(measurementId: number, isFinishAnalysis: boolean): Observable<string> {
    return this.apiClient
      .get<SamplesReportData>(`/api/measurements/${measurementId}/samples`, {isFinishAnalysis: `${isFinishAnalysis}`})
      .pipe(
        map(samplesReportData=> samplesReportData.data)
      );
  }

  sendHeartbeat(measurementId: number): Observable<void> {
    return this.apiClient.put(`/api/measurements/${measurementId}/analysing`);
  }

  getAnalysers(measurementId: number): Observable<Doctor[]> {
    return this.apiClient.get<Doctor[]>(`/api/measurements/${measurementId}/analysers`);
  }
}

interface SamplesReportData{
  data: string;
}
